import React from 'react'

import { Localized } from '../../localization/react'
import { Interval, Repeating, UsageLimitPeriod, UsageLimitTotal } from '../../typings/Product'

import { UsageLimitPeriodInformation } from './UsageLimitPeriodInformation'

interface Props {
  validUntil?: string | null
  usageLimitPeriod?: UsageLimitPeriod | null
  usageLimitTotal?: UsageLimitTotal | null
  repeating?: Repeating | null
  validityDuration?: Interval | null
}

const AssignedProductUsageInformation: React.FC<React.PropsWithChildren<Props>> = ({
  validUntil,
  usageLimitPeriod,
  usageLimitTotal,
  repeating,
  validityDuration,
}) => {
  const ValidUntil = validUntil ? (
    <Localized id="assigned-product-valid-until" params={{ validUntil: new Date(validUntil) }} />
  ) : null

  const UsageLimitTotalInformation = usageLimitTotal ? (
    <Localized
      id="assigned-product-usage-limit-total"
      params={{
        usagesLeft: usageLimitTotal.totalUsages - usageLimitTotal.usedUsages,
      }}
    />
  ) : null

  return (
    <>
      {ValidUntil}
      {UsageLimitTotalInformation}
      {usageLimitPeriod && (
        <UsageLimitPeriodInformation
          usageLimitPeriod={usageLimitPeriod}
          repeating={repeating}
          validityDuration={validityDuration}
        />
      )}
    </>
  )
}

export default AssignedProductUsageInformation
